<div class="row">
    <div class="col">

        <div class="h-100">
            <div class="row mb-3 pb-1">
                <div class="col-12">
                    <div class="d-flex align-items-lg-end flex-lg-row flex-column">
                        <div class="col-lg-4">
                            <h4 class="fs-16 mb-1">Welcome, {{userContext!.firstName || userContext!.userName || "User" }}</h4>
                            <p class="text-muted mb-0">Here's what's happening with your requisitions
                            </p>
                            
                        </div>
                        <div class="mt-3 mt-lg-0 col-lg-8 justify-content-end d-flex row mb-0 gap-1" style="justify-content: end;">
                          
                            <div *ngIf="loginType == 0" class="col-12 col-md-6 mb-2">
                                    <app-client-list-dropdown class="form-control p-0 overflowNoScrollBars" [display] = 3 [(referenceModel)] = "clientStatsModel" (referenceModelChange) = "clientChosen(clientStatsModel)"></app-client-list-dropdown> 
                            </div>
             
        
                            <div *ngIf="dateSelectTypeSelected != 'Exact Date' "  class="col-12 col-md-4 mb-2">
                                <app-ng-select-layout [placeHolderText]="'Select State'" [(model)]="dateSelectTypeSelected" (modelChange)="fetchData()" [items]="dateSelectOptions" ></app-ng-select-layout>
                            </div> 
                            <div *ngIf="dateSelectTypeSelected == 'Exact Date' " class="col-12 col-md-4 d-flex inline-flex gap-1 mb-2" >
                                <div class="col">
                                    <div class="input-group d-flex form-control" style="padding: 0%;"  [ngClass]="{'is-invalid': ((dateOfLossVal.invalid || (stringLengthValidation(currentDate) != 10)) && (dateOfLossVal.dirty || dateOfLossVal.touched))}" >
                                        <input class=" flex-shrink-1 form-control " #dateOfLossVal="ngModel"  [dropSpecialCharacters]="false" style="border-width: 0;" [pattern]=datePattern type="text" [(ngModel)]="currentDate" placeholder="DD/MM/YYYY" mask="00/00/0000" (keyup)="exactDateChosen()"/>     
                                        <span class=" input-group-text ri-calendar-2-line " style="  align-self: center; border-width: 0;" type="text" mwlFlatpickr [disableMobile]="true"  [(ngModel)]="currentDate" [dateFormat]="'d/m/Y'" (ngModelChange)="exactDateChosen()" ></span>
                                    </div>
                                    <div *ngIf="((dateOfLossVal.invalid || (stringLengthValidation(currentDate) != 10)) && (dateOfLossVal.dirty || dateOfLossVal.touched))" 
                                        class='invalidInputTextMessage' > 
                                        <div *ngIf="(dateOfLossVal.invalid || (stringLengthValidation(currentDate) != 10))">
                                            <div i18n = "@@">Exact Date Invalid</div>
                                        </div>
                                    </div>
                                </div>
                                <select #dateSelect="ngModel" class="form-select" style="padding-right: 0; padding-left: 0; font-size: 0; width: 20px; max-height: 38px;  background-position: center" [(ngModel)]="dateSelectTypeSelected" (change)="fetchData()" >
                                    <option *ngFor="let dateSelect of dateSelectOptions">
                                        {{dateSelect}}
                                    </option>    
                                </select>
                            </div>
                            
                            <button type="button" class=" btn btn-soft-info btn-icon waves-effect waves-light" style="width: 50px; margin-right: 12px;"
                                (click)="toggleActivity()">
                                <i class='bx bxs-notepad' style="font-size: 30px;"></i>
                            </button>      
                        </div>
                    </div>
                </div>
               
            </div>
          

            <div class="row justify-content-center d-flex">
               <div class="flex-grow-1" style="max-width: 20%; min-width: 200px;">
                    <div class="card card-animate card-animatePurple justify-content-center text-center">
                      
                        <div class="card-body">
                            <h5 class="mb-1">Draft</h5>
                        </div>
                        <div class="card-footer border-top border-top-dashed d-inline-flex gap-2" >
                            <div class="d-flex align-items-center flex-grow-1 justify-content-center" style="padding-top: 0.5rem;" >
                                <h4 class="fs-22 fw-semibold ff-secondary mb-4"><span class="counter-value">{{dashboardDataModel.totalDraft}}</span></h4>
                            </div>    
                            <div *ngIf="canViewRequisitionList" class="avatar-sm flex-shrink-0 flex-shrink"  style="cursor:pointer;" [routerLink]='"/requisitions/list"' fragment='0'>
                                <span class="rounded fs-3"  >
                                    <i class="bx bx-link-external" style=" color: #865ce2; font-size: 32px;" ></i>
                                </span>
                            </div>           
                        </div>
                    </div>
                </div>
               <div class="flex-grow-1" style="max-width: 20%; min-width: 200px;">
                    <div class="card card-animate  card-animateBlue justify-content-center text-center">
                      
                        <div class="card-body">
                            <h5 class="mb-1">Submitted</h5>
                        </div>
                        <div class="card-footer border-top border-top-dashed d-inline-flex gap-2" >
                            <div class="d-flex align-items-center flex-grow-1 justify-content-center" style="padding-top: 0.5rem;" >
                                <h4 class="fs-22 fw-semibold ff-secondary mb-4"><span class="counter-value">{{dashboardDataModel.totalSubmitted}}</span></h4>
                            </div>    
                            <div *ngIf="canViewRequisitionList" class="avatar-sm flex-shrink-0 flex-shrink"  style="cursor:pointer;" [routerLink]='"/requisitions/list"' fragment='1'>
                                <span class="rounded fs-3"  >
                                    <i class="bx bx-link-external" style=" color: #33A6FF; font-size: 32px;" ></i>
                                </span>
                            </div>           
                        </div>
                    </div>
                </div>
               <div class="flex-grow-1" style="max-width: 20%; min-width: 200px; ">
                    <div class="card card-animate card-animateOrange justify-content-center text-center">
                      
                        <div class="card-body">
                            <h5 class="mb-1">Processing</h5>
                        </div>
                        <div class="card-footer border-top border-top-dashed d-inline-flex gap-2" >
                            <div class="d-flex align-items-center flex-grow-1 justify-content-center" style="padding-top: 0.5rem;" >
                                <h4 class="fs-22 fw-semibold ff-secondary mb-4"><span class="counter-value">{{dashboardDataModel.totalProcessing }}</span></h4>
                            </div>    
                            <div *ngIf="canViewRequisitionList" class="avatar-sm flex-shrink-0 flex-shrink"  style="cursor:pointer;" [routerLink]='"/requisitions/list"' fragment='2'>
                                <span class="rounded fs-3"  >
                                    <i class="bx bx-link-external" style=" color: #f1963b; font-size: 32px;" ></i>
                                </span>
                            </div>           
                        </div>
                    </div>
                </div>
                <div class="flex-grow-1" style="max-width: 20%; min-width: 200px;">
                    <div class="card card-animate card-animateGreen justify-content-center text-center">
                      
                        <div class="card-body">
                            <h5 class="mb-1">Completed</h5>
                        </div>
                        <div class="card-footer border-top border-top-dashed d-inline-flex gap-2">
                          
                            <div class="d-flex align-items-center flex-grow-1 justify-content-center" style="padding-top: 0.5rem;" >
                                <h4 class="fs-22 fw-semibold ff-secondary mb-4  "><span class="counter-value">{{dashboardDataModel.totalCompleted }}</span></h4>   
                               
                            </div>
                            <div *ngIf="canViewRequisitionList" class="avatar-sm flex-shrink-0 flex-shrink"  style="cursor:pointer;" [routerLink]='"/requisitions/list"' fragment='3'>
                                <span class="rounded fs-3" >
                                    <i class="bx bx-link-external" style=" color: #13c56b; font-size: 32px;" ></i>
                                </span>  
                            </div>     
                        </div>
                    </div>
                </div>
               <div class="flex-grow-1" style="max-width: 20%; min-width: 200px;">
                    <div class="card card-animate card-animateRed justify-content-center text-center">
                      
                        <div class="card-body">
                            <h5 class="mb-1">Incompleted</h5>
                        </div>
                        <div class="card-footer border-top border-top-dashed d-inline-flex gap-2" >
                            <div class="d-flex align-items-center flex-grow-1 justify-content-center" style="padding-top: 0.5rem;" >
                                <h4 class="fs-22 fw-semibold ff-secondary mb-4"><span class="counter-value">{{dashboardDataModel.totalIncompleted}}</span></h4>
                            </div>    
                            <div *ngIf="canViewRequisitionList" class="avatar-sm flex-shrink-0 flex-shrink"  style="cursor:pointer;" [routerLink]='"/requisitions/list"' fragment='4'>
                                <span class="rounded fs-3"  >
                                    <i class="bx bx-link-external" style=" color: #ed5e5e; font-size: 32px;" ></i>
                                </span>
                            </div>           
                        </div>
                    </div>
                </div>
            </div> 

            <div class="row">
                <div class="col-12 col-xl-6">
                    <div class="card" style="height: 94%">
                        <div class="card-header align-items-center d-flex">
                            <h4 class="card-title mb-0 flex-grow-1">Requisitions Status</h4>
                            <div class="flex-shrink-0">
                                <div class="dropdown card-header-dropdown" ngbDropdown>
                                </div>
                            </div>
                        </div>
                        <div class="card-body p-0 mb-3">
                            <div class="w-100">
                                <apx-chart class="apex-charts" 
                                    [series]="donutChart.series"
                                    [chart]="donutChart.chart"
                                    [labels]="donutChart.labels"
                                    [responsive]="donutChart.responsive"
                                ></apx-chart>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-xl-6">
                    <div class="card">
                        <div class="card-header align-items-center d-flex">
                            <h4 class="card-title mb-0 flex-grow-1">MyFile Status Summary</h4>
                            <div class="flex-shrink-0">
                                <div class="dropdown card-header-dropdown" ngbDropdown>
                                </div>
                            </div>
                        </div>
                        <div class="card-body p-0 pb-2">
                            <div class="w-100">
                                <apx-chart class="apex-charts" [series]="barChart.series" [chart]="barChart.chart" [colors]="barChart.colors" [dataLabels]="barChart.dataLabels"
                            [plotOptions]="barChart.plotOptions" [yaxis]="barChart.yaxis" [legend]="barChart.legend"
                            [fill]="barChart.fill" [stroke]="barChart.stroke" [tooltip]="barChart.tooltip"
                            [xaxis]="barChart.xaxis" dir="ltr"></apx-chart>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-6">
                    <div class="card">
                        <div class="card-header border-0 align-items-center d-flex">
                            <h4 class="card-title mb-0 flex-grow-1"> Witness Progress  </h4> 
                        </div>

                        <div class="card-header p-0 border-0 bg-soft-light">
                            <div class="row g-0 text-center">
                                <div class="col-6 " style="background-color: rgba(127, 17, 224, .03);">
                                    <div class="p-3 border border-dashed border-start-0">
                                        <h5 class="mb-1"><span class="counter-value">{{dashboardDataModel.totalDraft}}</span></h5>
                                        <p class="text-muted mb-0">Draft</p>
                                    </div>
                                </div>
                               
                                <div class="col-6" style="background-color: rgba(102, 145, 231, .03);">
                                    <div class="p-3 border border-dashed border-start-0">
                                        <h5 class="mb-1"><span class="counter-value">{{dashboardDataModel.totalSubmitted }}</span></h5>
                                        <p class="text-muted mb-0">Submitted</p>
                                    </div>
                                </div>
                               
                            </div>
                        </div>

                        <div class="card-body p-0 pb-2">
                            <div class="w-100" >
                                <apx-chart class="apex-charts"  [series]="witnessChart.series" [chart]="witnessChart.chart"
                                [colors]="witnessChart.colors" [dataLabels]="witnessChart.dataLabels"
                                [stroke]="witnessChart.stroke" [series]="witnessChart.series"
                                [title]="witnessChart.title" [markers]="witnessChart.markers"
                                [xaxis]="witnessChart.xaxis" [tooltip]="witnessChart.tooltip"
                                [grid]="witnessChart.grid" dir="ltr"></apx-chart>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="col-xl-6">
                    <div class="card">
                        <div class="card-header border-0 align-items-center d-flex">
                            <h4 class="card-title mb-0 flex-grow-1">MyFile Progress</h4>
                        </div>

                        <div class="card-header p-0 border-0 bg-soft-light">
                            <div class="row g-0 text-center">
                                <div class="col-6 col-sm-4"  style="background-color: rgba(241, 150, 59, .03);">
                                    <div class="p-3 border border-dashed border-start-0">
                                        <h5 class="mb-1"><span class="counter-value" >{{dashboardDataModel.totalProcessing}}</span></h5>
                                        <p class="text-muted mb-0">Processing</p>
                                    </div>
                                </div>
                               
                                <div class="col-6 col-sm-4"  style="background-color: rgba(19, 197, 107, .03);">
                                    <div class="p-3 border border-dashed border-start-0">
                                        <h5 class="mb-1"><span  class="counter-value">{{dashboardDataModel.totalCompleted}}</span></h5>
                                        <p class="text-muted mb-0">Completed</p>
                                    </div>
                                </div>
                                <div class="col-6 col-sm-4"  style="background-color: rgba(237, 94, 94, .03);">
                                    <div class="p-3 border border-dashed border-start-0">
                                        <h5 class="mb-1"><span class="counter-value">{{dashboardDataModel.totalIncompleted }}</span></h5>
                                        <p class="text-muted mb-0">Incompleted</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="card-body p-0 pb-2">
                            <div class="w-100">
                                <apx-chart class="apex-charts" [chart]="myfileChart.chart"
                                    [series]="myfileChart.series" [legend]="myfileChart.legend"
                                    [stroke]="myfileChart.stroke" [colors]="myfileChart.colors"
                                    [fill]="myfileChart.fill" [dataLabels]="myfileChart.dataLabels"
                                    [xaxis]="myfileChart.xaxis" [markers]="myfileChart.markers"
                                    [plotOptions]="myfileChart.plotOptions" [yaxis]="myfileChart.yaxis"
                                    [tooltip]="myfileChart.tooltip" [grid]="myfileChart.grid"
                                    [labels]="myfileChart.labels" dir="ltr">
                                </apx-chart>
                            </div>
                        </div>
                    </div>
                </div>  
            </div>
        </div> 

    </div> 

    <div class="col-auto layout-rightside-col">
        <div class="overlay" (click)="SidebarHide()"></div>
        <div class="layout-rightside">
            <div class="card rounded-0" >
                <div class="card-body p-0" >
                    <div class="p-3">
                        <h6 class="text-muted mb-0 text-uppercase">Recent Activity</h6>
                    </div>

                    <app-timeline-modal [display] = "2" ></app-timeline-modal>
                 
                </div>
            </div> 
        </div> 

    </div> 
</div>
<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>